<template>
  <div class="bgc login-box extra">
    <!-- <div style="font-size: 18px;margin: 50px 0px 0 0;text-align: center;">tiktok运营服务 开发调试登录</div> -->
    <div class="box-flex">
      <div class="login-main">
        <!-- <p class="p-h20">跳转地址</p>
        <el-input
          maxlength="20"
          v-model="goto_path"
          @keyup.enter.native="toLogin"
          placeholder="需要跳转的路径，无则跳转项目页面"
        ></el-input> -->
        <p class="p-h20">用户名</p>
        <el-input maxlength="20" v-model="username" @keyup.enter.native="toLogin" placeholder="用户名"></el-input>
        <p class="p-h20">密码</p>
        <el-input type="password" @keyup.enter.native="toLogin" maxlength="20" v-model="password" placeholder="密码">
        </el-input>
        <div style="margin-top: 20px"></div>
        <el-button @click="toLogin" class="LoginBtn" type="primary">登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { loginDev } from '../request'
import store from '@/store'
export default {
  data() {
    return {
      //账号
      username: '',
      //密码
      password: '',
      //记住密码
      checked: false,
      isMobile: false,
      goto_path: '',
    }
  },
  created() {
    this.isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)

    if (this.username) this.checked = true
  },
  methods: {
    WeChatLoginFn() {
      localStorage.setItem('LogOut', 1)
    },
    toLogin() {
      if (!this.username) {
        return this.$message.error('请输入工号或姓名')
      } else if (this.username.length < 2 || this.username.length > 16) {
        return this.$message.error('请输入正确格式的工号或姓名')
      }

      if (!this.password) {
        return this.$message.error('请输入密码')
      } else if (this.password.length < 5) {
        return this.$message.error('请输入大于4位数的密码')
      } else if (this.password.length >= 20) {
        return this.$message.error('请输入小于20位数的密码')
      }

      let param = {
        username: this.username,
        password: this.password,
      }
      loginDev(param).then((res) => {
        if (res.error == 0) {
          localStorage.setItem('token', res.data.authorization)
          sessionStorage.setItem('token', res.data.authorization)
          store.commit('SET_TOKEN', res.data.authorization)
          sessionStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
          if (this.goto_path) {
            this.$router.push({ path: this.goto_path })
          } else {
            this.$router.replace({ path: '/ef-seller' })
          }
          //   this.$store.dispatch('GetInfo').then((res) => {

          //   })
        }
      })
    },
  },
}
</script>

<style>
.bgc .el-button + .el-button {
  margin-left: 0;
}
</style>

<style scoped lang="less">
.fr {
  float: right;
}
.login-box.extra {
  min-width: 1500px;
}
@deep: ~'>>>';

@{deep} .mobileLoginBtn {
  &.el-button--success {
    background-color: #30ada0;
    border-color: #30ada0;
    width: 5.3rem;
  }
}
.other-way {
  margin-top: 30px;
  border-top: 1px solid #ddd;
  padding-top: 18px;
  text-align: center;
  p {
    margin-bottom: 20px;
  }
}
a.enterprise {
  display: inline-block;
  height: 45px;
  width: 45px;
  margin: 0 10px;
  background: url(../assets/img/icons_loginway.png) no-repeat;
  -webkit-transition: background-position 0.2s ease;
  -moz-transition: background-position 0.2s ease;
  -ms-transition: background-position 0.2s ease;
  -o-transition: background-position 0.2s ease;
  transition: background-position 0.2s ease;
  background-position: -135px 0;
  background-size: 180px 90px;
  &:hover {
    background-position: -135px -45px;
  }
}
.page-button {
  width: 100%;
  box-sizing: border-box;
  height: 60px;
  line-height: 60px;
  position: fixed;
  bottom: 0;
  z-index: 10;
  left: 0;
  text-align: center;
  background: #fff;
  span,
  a {
    display: inline-block;
    margin: 0 20px;
    color: #333;
  }
  a {
    text-decoration: underline;
    &:hover {
      opacity: 0.8;
    }
  }
}
.p-h20 {
  height: 20px;
  line-height: 20px;
}
.el-input {
  margin: 8px 0;
}
.bgc {
  background-color: rgb(255, 255, 255);
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
}
.box-flex {
  width: 100%;
  // width: 400px;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  margin: auto 0;
  .login_bg {
    display: block;
    margin: -60px auto;
  }
  .LoginBtn {
    width: 100%;
  }
  .login-main {
    width: 400px;
    /* margin: auto 0; */
    display: block;
    position: absolute;
    left: 50%;
    margin-left: -200px;
    top: 50%;
    margin-top: -200px;
  }
  &.mobile {
    text-align: center;
    width: 7.5rem;
    margin: 0;
    margin-top: 2rem;
    .login-main {
      display: inline-block;
      padding: 0;
      box-shadow: none;
      border: none;
      width: 5.3rem;
      position: initial;
      left: 0;
      margin-top: 50px;
      margin-left: 0;
    }
    .login_bg {
      width: 5rem;
    }
  }
}

.login-main {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  color: #000;
  border: 1px solid #ccc;
  box-shadow: 0px 0px 10px #ccc;
  padding: 20px;
  box-sizing: border-box;
  font-size: 14px;
}
.forget-box {
  height: 20px;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}
.forget {
  color: red;
}
button {
  font-size: 20px;
}
</style>
